module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vskel13-317042083315b25f8288096cbfd2410c.jpg";